import { render, staticRenderFns } from "./ConsultarAtivacaoCadastroForm.vue?vue&type=template&id=5cb4315e&scoped=true"
import script from "./ConsultarAtivacaoCadastroForm.vue?vue&type=script&lang=js"
export * from "./ConsultarAtivacaoCadastroForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultarAtivacaoCadastroForm.vue?vue&type=style&index=0&id=5cb4315e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4315e",
  null
  
)

export default component.exports